module.exports = __webpack_public_path__ + "static/media/JW-marriot07.314cd903.jpg";